// Catalog client IDs connect repeat loans; names and phone numbers can be shared.
export function financeLoanHistory(accounts) {
  const groups = new Map();
  accounts.forEach(account => {
    const key = account.stakeholderId ? `client:${account.stakeholderId}` : `account:${account._id}`;
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(account);
  });
  const currentIds = new Set();
  const previous = new Map();
  groups.forEach(group => {
    const sorted = [...group].sort((a, b) => String(b.createdAt || b.disbursedDate || '').localeCompare(String(a.createdAt || a.disbursedDate || '')));
    const active = sorted.filter(row => !row.closure);
    const current = active.length ? active : sorted.slice(0, 1);
    current.forEach(row => {
      currentIds.add(row._id);
      previous.set(row._id, sorted.filter(old => old.closure && old._id !== row._id));
    });
  });
  return { current: accounts.filter(row => currentIds.has(row._id)), previous };
}
